import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import "./dealership-thank-you.css";

const DealershipThankYou = ({ small,state }) => {
  const [data, setData] = useState({});

  const dealershipDetails = useSelector(
    (state) => state?.Landing?.dealershipDetails
  );
  useEffect(() => {
    window.scrollTo(0, 0);
    if (dealershipDetails) {
      setData(dealershipDetails);
    }
  }, [dealershipDetails]);
  return (
    <div class="container" style={{ paddingInline: small && 0 }}>
      <h3
        class="section_heading"
        style={{ margin: 20, width: "auto", fontSize: small && "1.5rem" }}
      >
        Your dealership from id is
      </h3>
      <h3
        class="booking_id"
        style={{ margin: 20, fontSize: small && "1.5rem" }}
      >
        #DL{dealershipDetails?.responseBody?.id}
      </h3>

      <table class="details_table" style={{ margin: 20 }}>
        <tr>
          <th colspan="2">Personal Information</th>
        </tr>

        <tr>
          <td>Salutation</td>
          <td className="td">{state.dealershipName}</td>
        </tr>
        <tr>
          <td>First Name</td>
          <td className="td">{state.firstName}</td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td className="td">{state.lastName}</td>
        </tr>

        <tr>
          <td>Phone Number</td>
          <td className="td">{state.phone}</td>
        </tr>

        <tr>
          <td>Email ID</td>
          <td className="td">{state.email}</td>
        </tr>

        <tr>
          <td>Date of Birth</td>
          <td className="td">{state.dob}</td>
        </tr>

        <tr>
          <td>Educational Qualification</td>
          <td className="td">{state.educationalQualification}</td>
        </tr>

        <tr>
          <td>Address</td>
          <td className="td">{state.street}</td>
        </tr>

        <tr>
          <td>State</td>
          <td className="td">{state.state}</td>
        </tr>

        <tr>
          <td>City</td>
          <td className="td">{state.currentBusinessDetails}</td>
        </tr>

        <tr>
          <td>Pin Code</td>
          <td className="td">{data?.pincode}</td>
        </tr>
      </table>

      <table class="details_table" style={{ margin: 20 }}>
        <tr>
          <th colspan="2">Business Information</th>
        </tr>

        <tr>
          <td>Partnership Type</td>
          <td className="td">{state.partnership}</td>
        </tr>

        <tr>
          <td>State Applied For</td>
          <td className="td">{state.stateAppliedFor}</td>
        </tr>

        <tr>
          <td>City Applied For</td>
          <td className="td">{state.cityAppliedFor}</td>
        </tr>

        <tr>
          <td>Current Business Details</td>
          <td className="td">{state.currentBusinessDetails}</td>
        </tr>

        <tr>
          <td>Automotive Industry Experience</td>
          <td className="td">{state.industryExperience}</td>
        </tr>

        <tr>
          <td>Number of Years in Business</td>
          <td className="td">{state.yearsOfExperience}</td>
        </tr>

        <tr>
          <td>Which companies have you partnered with?</td>
          <td className="td">{state.companiesPartneredWith}</td>
        </tr>

        <tr>
          <td>Annual Turnover (in Lakhs)</td>
          <td className="td">{state.annualTurnover}</td>
        </tr>

        <tr>
          <td>Land Details</td>
          <td className="td">{state.landDetail}</td>
        </tr>

        <tr>
          <td>Comments</td>
          <td className="td">{state.additionalComments}</td>
        </tr>

        <tr>
          <td>What is the approximate amount you are willing to invest?</td>
          <td className="td">{state.approaxAmountToInvest}</td>
        </tr>
      </table>

      <h4 class="contact_info" style={{ margin: 20 }}>
        In case of any enquiry, Contact us at <strong>1800 1238 1238</strong>
      </h4>
    </div>
  );
};

export default DealershipThankYou;
